import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  class="revise-and-reject-reviewable"
  @closeModal={{@closeModal}}
  @title={{i18n "review.revise_and_reject_post.title"}}
>
  <:body>
    <div class="revise-and-reject-reviewable__queued-post">
      <ReviewableQueuedPost @reviewable={{@model.reviewable}} @tagName="" />
    </div>

    <div class="control-group">
      <label class="control-label" for="reason">{{i18n
          "review.revise_and_reject_post.reason"
        }}</label>
      <ComboBox
        @name="reason"
        @content={{this.configuredReasons}}
        @value={{this.reason}}
        @onChange={{fn (mut this.reason)}}
        class="revise-and-reject-reviewable__reason"
      />
    </div>

    {{#if this.showCustomReason}}
      <div class="control-group">
        <label class="control-label" for="custom_reason">{{i18n
            "review.revise_and_reject_post.custom_reason"
          }}</label>
        <Input
          name="custom_reason"
          class="revise-and-reject-reviewable__custom-reason"
          @type="text"
          @value={{this.customReason}}
        />
      </div>
    {{/if}}

    <div class="control-group">
      <label class="control-label" for="feedback">{{i18n
          "review.revise_and_reject_post.feedback"
        }}
        <span class="revise-and-reject-reviewable__optional">({{i18n
            "review.revise_and_reject_post.optional"
          }})</span>
      </label>
      <DTextarea
        @name="feedback"
        @value={{this.feedback}}
        @onChange={{fn (mut this.feedback)}}
        class="revise-and-reject-reviewable__feedback"
      />
    </div>
  </:body>
  <:footer>
    <DButton
      class="btn-primary"
      @action={{this.rejectAndSendPM}}
      @disabled={{this.sendPMDisabled}}
      @label="review.revise_and_reject_post.send_pm"
    />
    <DButton
      class="btn-flat d-modal-cancel"
      @action={{@closeModal}}
      @label="cancel"
    />
  </:footer>
</DModal>
*/
{
  "id": "k1CGihAa",
  "block": "[[[8,[39,0],[[24,0,\"revise-and-reject-reviewable\"]],[[\"@closeModal\",\"@title\"],[[30,1],[28,[37,1],[\"review.revise_and_reject_post.title\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"revise-and-reject-reviewable__queued-post\"],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@reviewable\",\"@tagName\"],[[30,2,[\"reviewable\"]],\"\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"reason\"],[12],[1,[28,[35,1],[\"review.revise_and_reject_post.reason\"],null]],[13],[1,\"\\n      \"],[8,[39,3],[[24,0,\"revise-and-reject-reviewable__reason\"]],[[\"@name\",\"@content\",\"@value\",\"@onChange\"],[\"reason\",[30,0,[\"configuredReasons\"]],[30,0,[\"reason\"]],[28,[37,4],[[28,[37,5],[[30,0,[\"reason\"]]],null]],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showCustomReason\"]],[[[1,\"      \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"custom_reason\"],[12],[1,[28,[35,1],[\"review.revise_and_reject_post.custom_reason\"],null]],[13],[1,\"\\n        \"],[8,[39,7],[[24,3,\"custom_reason\"],[24,0,\"revise-and-reject-reviewable__custom-reason\"]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"customReason\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"feedback\"],[12],[1,[28,[35,1],[\"review.revise_and_reject_post.feedback\"],null]],[1,\"\\n        \"],[10,1],[14,0,\"revise-and-reject-reviewable__optional\"],[12],[1,\"(\"],[1,[28,[35,1],[\"review.revise_and_reject_post.optional\"],null]],[1,\")\"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,8],[[24,0,\"revise-and-reject-reviewable__feedback\"]],[[\"@name\",\"@value\",\"@onChange\"],[\"feedback\",[30,0,[\"feedback\"]],[28,[37,4],[[28,[37,5],[[30,0,[\"feedback\"]]],null]],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,9],[[24,0,\"btn-primary\"]],[[\"@action\",\"@disabled\",\"@label\"],[[30,0,[\"rejectAndSendPM\"]],[30,0,[\"sendPMDisabled\"]],\"review.revise_and_reject_post.send_pm\"]],null],[1,\"\\n    \"],[8,[39,9],[[24,0,\"btn-flat d-modal-cancel\"]],[[\"@action\",\"@label\"],[[30,1],\"cancel\"]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"i18n\",\"reviewable-queued-post\",\"combo-box\",\"fn\",\"mut\",\"if\",\"input\",\"d-textarea\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/revise-and-reject-post-reviewable.hbs",
  "isStrictMode": false
});